import {
  AddEditAttributePopup,
  AddEditComponentAttributePopup,
} from '../legacy-bridge';
import type { CartonKind, CartonRow } from '../lib/rows';

export type CartonAliasTarget = {
  row: CartonRow;
  /** The alias to edit; none adds a new one. */
  alias?: string;
};

/** Adds or edits one carton alias of an item or component (legacy dialog). */
export function CartonAliasPopup({
  kind,
  target,
  imperial,
  onClose,
  onSaved,
}: {
  kind: CartonKind;
  target: CartonAliasTarget | null;
  imperial: boolean;
  onClose: () => void;
  onSaved: () => void;
}) {
  const shared = {
    open: !!target,
    closeModal: onClose,
    attributes: target?.row.aliases ?? [],
    currentAlias: target?.alias ?? '',
    imperial,
    refetch: onSaved,
    addByTextbox: !target?.alias,
  };

  return kind === 'items' ? (
    // @ts-expect-error - the legacy popup's optional props are typed as required.
    <AddEditAttributePopup {...shared} itemUPC={target?.row.itemUpc} />
  ) : (
    // @ts-expect-error - the legacy popup's optional props are typed as required.
    <AddEditComponentAttributePopup {...shared} componentId={target?.row.id} />
  );
}
